'use strict';

$(document).on('click', '.go-to-cart-btn', function (e) {
    e.stopPropagation();
    e.preventDefault();

    var url = $(this).data('url');
    $.spinner().start();
    window.location.href = url;
});
